enum DentalInsuranceProcessStepEnum {
  RATER = 1, // Tarificacion
  DOCUMENTS = 2, // Documentos
  HOLDER = 3, // Tomador
  INSUREDS = 4, // Asegurados
  PAYMENT = 5, // MediosPago
  SIGN = 6, // Firma
  EMISSION = 7 // Emision
}

export default DentalInsuranceProcessStepEnum
